<bb-page-header [icon]="'sliders'" [title]="'PLAYOUTS' | translate" [filterConfig]="filterConfig"
	[currentPath]="listConfiguration.activePath">
</bb-page-header>

<div class="body-column">

	<div class="action-buttons">
		<a class="button" [routerLink]="['/library/playout', 'new', 'appearance']"><i class="fa fa-plus"></i>
			<span class="short-label">{{ 'CREATE_NEW' | translate }}</span>
			<span class="long-label">{{ 'CREATE_NEW_PLAYOUT' | translate }}</span>
		</a>

		<div class="with-selected" [ngClass]="{'has-selected': selectedRows.length > 0}">
			<span *ngIf="!selectedRows || selectedRows.length === 0" class="selected-label">{{ 'NO_PLAYOUTS_SELECTED' |
				translate }}</span>
			<span *ngIf="selectedRows.length > 0" class="selected-label">{{ 'WITH_SELECTED' | translate : {value:
				selectedRows.length} }}:</span>

			<span [ngClass]="{disabled: !putRight || !selectedRows || selectedRows.length !== 1}" class="button"
				(click)="setDefault()">
				<i class="fa fa-check"></i>{{ "SET_AS_DEFAULT" | translate }}
			</span>

			<span [ngClass]="{disabled: !putRight || !selectedRows || selectedRows.length === 0}" class="button"
				(click)="setStatus(null, hasInactiveSelected ? 'active' : 'inactive')">
				<i class="fa fa-circle"></i>{{ (hasInactiveSelected ? 'ACTIVATE' : 'DEACTIVATE') | translate }}
			</span>

			<span [ngClass]="{disabled: !deleteRight || !selectedRows || selectedRows.length === 0}" class="button"
				(click)="deleteSelected()">
				<i class="fa fa-trash"></i>{{ 'DELETE' | translate }}
			</span>
		</div>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="label" class="overflow">{{ 'CODE' | translate }}
			</bb-table-header-cell>
			<bb-table-header-cell property="main">{{ 'DEFAULT' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="responsiveSizing">{{ 'RESPONSIVE' | translate }}
			</bb-table-header-cell>
			<bb-table-header-cell property="width">{{ 'WIDTH' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="height">{{ 'HEIGHT' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-logo">{{ 'LOGO' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-colors">{{ 'COLORS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status" class="column-statusicon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="createddate">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="title" class="overflow">{{ row.data.name }}</bb-table-cell>
			<bb-table-cell optional property="label" class="overflow">{{ row.data.label }}</bb-table-cell>
			<bb-table-cell property="main"><span [hidden]="!row.data.main"><i class="fa fa-check"></i></span>
			</bb-table-cell>
			<bb-table-cell optional property="responsiveSizing"><span [hidden]="row.data.responsiveSizing !== 'true'"><i
						class="fa fa-check"></i></span></bb-table-cell>
			<bb-table-cell property="width">{{ row.data.width }}</bb-table-cell>
			<bb-table-cell property="height">
				<span [hidden]="row.data.responsiveSizing !== 'true'">{{ 'NOT_APPLICABLE' | translate }}</span>
				<span [hidden]="row.data.responsiveSizing === 'true'">{{ row.data.height }}</span>
			</bb-table-cell>
			<bb-table-cell class="column-logo"><img *ngIf="row.data.logoId"
					src="{{logoPrefix + '/mediaclip/' + row.data.logoId + '/spthumbnail/default/60.png?sesstoken=' + sessionToken}}">
			</bb-table-cell>
			<bb-table-cell class="column-colors">
				<div [innerHtml]="row.data | colors"></div>
			</bb-table-cell>
			<bb-table-cell property="status" class="column-statusicon">
				<div [innerHtml]="row.data | statusIcon"></div>
			</bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{
				row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}
			</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{
				row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}
			</bb-table-cell>

			<bb-table-cell class="buttons" (click)="$event.stopPropagation()">
				<!-- stopPropagation so the row doesn't get selected -->
				<a class="button" [routerLink]="['/library/playout', row.data.id, 'appearance']">
					<i class="fa fa-edit" (easterEgg)="showData(row.data.id)"></i>
				</a>
				<a class="button" (click)="duplicate(row.data.id)">
					<i class="fa fa-copy"></i>
				</a>
				<a class="button" [ngClass]="{disabled: !putRight || row?.data?.label === 'default'}"
					(click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>
			</bb-table-cell>

		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_PLAYOUTS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>

</div>
